import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Style } from '@app/shared/components/atoms/icon/icon.component';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  standalone: false,
})
export class PasswordInputComponent {
  @Input() id: string = '';

  @Input() formCtrl: FormControl = new FormControl();

  @Input() placeholder: string = '';

  // eslint-disable-next-line class-methods-use-this
  @Input() onChange: () => void = () => {};

  @Input() dataTestId: string = 'input';

  isPasswordVisible: boolean = false;

  onTogglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  protected readonly Style = Style;
}
